export var CameraType;
(function (CameraType) {
    CameraType["orthographic"] = "orthographic";
    CameraType["perspective"] = "perspective";
})(CameraType || (CameraType = {}));
